module.exports = __webpack_public_path__ + "6440cc7e6415deede25de64138417fff.png";